<template>
  <q-chip
    class="link-status-chip"
    data-test-id="link-status-chip"
    dense
    flat
    square
    outline
  >
    <span
      class="row items-center text-status-chip"
    >
      <q-icon
        class="q-mr-xs"
        :name="content.icon"
        :color="content.color"
        size="12px"
      />
      {{ content.label }}
    </span>
  </q-chip>
</template>

<script>
export default {
  name: 'LinkStatusChip',
  props: {
    descendant: {
      type: Object,
      required: false,
      default: null
    }
  },
  computed: {
    content () {
      if (_.isNil(this.descendant?.id)) {
        return {
          label: 'Not Linked',
          icon: 'far fa-burst',
          color: 'negative'
        }
      } else if (this.descendant.receiveLibraryUpdates) {
        return {
          label: 'Linked with Updates',
          icon: 'fa fa-badge-check',
          color: 'positive'
        }
      } else {
        return {
          label: 'Linked no Updates',
          icon: 'fa fa-link-horizontal-slash',
          color: 'info'
        }
      }
    }
  }
}

</script>

<style lang="scss" scoped>
  .link-status-chip {
    border-color: $grey-5;
  }

  .text-status-chip {
    font-size: 12px;
    font-weight: 500;
    text-transform: none;
    white-space: nowrap;
  }
</style>
